import _defineProperty from "E:/code/jinhua-step-two/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { Component, Vue } from "vue-property-decorator";
import { initData } from "@/api/api";
let IndexPage = class IndexPage extends Vue {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "init_data", []);

    _defineProperty(this, "base_url", process.env.VUE_APP_BASE_URL);
  }

  async created() {
    const res = await initData();
    this.init_data = res.data;
    this.geoLocation();
  } // 使用腾讯地图进行定位


  geoLocation() {
    const geolocation = new window.qq.maps.Geolocation("BF2BZ-KK7KU-4XXVV-BG2T4-4F3X5-F7FPV", "myweb");
    geolocation.getLocation(function (res) {
      console.log(res);
      localStorage.setItem("lng", res.lng);
      localStorage.setItem("lat", res.lat);
    }, function (err) {
      console.log(err);
    }, {
      timeout: 10000,
      failTipFlag: true
    });
  } // 点击导航


  clickItem(item) {
    if (item.id === 22) {
      window.location.href = item.address;
    } else {
      this.$router.push({
        path: "/scenic"
      });
      sessionStorage.setItem("scenic_data", JSON.stringify({
        id: item.id,
        longitude: item.longitude,
        latitude: item.latitude,
        maxZoom: item.maxZoom,
        minZoom: item.minZoom,
        showZoom: item.showZoom
      }));
    }
  }

};
IndexPage = __decorate([Component], IndexPage);
export default IndexPage;